import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Center } from 'src/app/models/center-model/center.model';

@Component({
  selector: 'app-centers-centers-breadcrumb-filter-card',
  templateUrl: './centers-centers-breadcrumb-filter-card.component.html',
  styleUrls: ['./centers-centers-breadcrumb-filter-card.component.scss']
})
export class CentersCentersBreadcrumbFilterCardComponent implements OnInit {

  @Input() centers;
  countries;
  types;
  countriesForm = new FormGroup({});
  typesForm = new FormGroup({});

  constructor(private centersCentersService: CentersCentersService,
              private userStorageService: UserStorageService) { }

  ngOnInit() {
    this.getCountries();
    this.getTypes();
    if (this.userStorageService.getFilterCenters()) {
      this.countriesForm.patchValue(this.userStorageService.getFilterCenters()['countriesForm']);
      this.typesForm.patchValue(this.userStorageService.getFilterCenters()['typesForm']);
    }
    this.filter();
  }

  public updateCheckbox(form, reset?) {
    this._toggleCheckboxes(form, reset);
  }

  private _toggleCheckboxes(form, reset) {
    if (reset && form.get('all').value) {
      Object.entries(form.controls).forEach(c => (c[0] !== 'all') ? (c[1] as FormControl).setValue(false) : null);
    } else if (Object.entries(form.controls).find(c => (c[0] !== 'all') && (c[1] as FormControl).value)) {
      form.get('all').setValue(false);
    } else if (!Object.entries(form.controls).find(c => (c[1] as FormControl).value)) {
      form.get('all').setValue(true);
    }
    this.userStorageService.setFilterCenters({ countriesForm: this.countriesForm.getRawValue(), typesForm: this.typesForm.getRawValue() });
    if (this.userStorageService.getFilterCenters()['countriesForm']['all'] && this.userStorageService.getFilterCenters()['typesForm']['all']) {
      this.userStorageService.deleteFilterCenters();
    }
    this.filter();
  }

  private getCountries() {
    const countries = new Array<string>();
    this.countriesForm.addControl('all', new FormControl(true));
    this.centers.forEach((d: Center) => {
      if (countries.indexOf(d.Country) === -1) {
        countries.push(d.Country);
        this.countriesForm.addControl(d.Country, new FormControl(false));
      }
    });
    this.countries = countries;
  }

  private getTypes() {
    const types = new Array<string>();
    this.typesForm.addControl('all', new FormControl(true));
    this.centers.forEach((d: Center) => {
      if (types.indexOf(d.CenterTypeName) === -1) {
        types.push(d.CenterTypeName);
        this.typesForm.addControl(d.CenterTypeName, new FormControl(false));
      }
    });
    this.types = types;
  }

  public filter() {
    const forms = {
      countriesForm:
      {
        attribute: 'Country',
        values: []
      },
      typesForm:
      {
        attribute: 'CenterTypeName',
        values: []
      }
    };
    if (this.countriesForm.get('all').value) {
      forms['countriesForm'].values = Object.keys(this.countriesForm.value).splice(1);
    } else {
      Object.entries(this.countriesForm.value).forEach(c => { if (c[1]) { forms['countriesForm'].values.push(c[0]); }});
    }
    if (this.typesForm.get('all').value) {
      forms['typesForm'].values = Object.keys(this.typesForm.value).splice(1);
    } else {
      Object.entries(this.typesForm.value).forEach(c => { if (c[1]) { forms['typesForm'].values.push(c[0]); }});
    }
    this.centersCentersService.filterCenters(forms);
  }
}
